// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"Contact_buttonsWrapper___z7pl","title":"Contact_title__OjoA3"};